import {
  InjectedLLMJudge,
  LLMJudgeError,
  type InjectedInvoker,
} from "./shared.js";

/**
 * Codex CLI host adapter for `LLMJudge`.
 *
 * Codex's natural surface for a single-shot decision query is an **inline
 * completion** — the host runs the framed prompt as a one-off completion and
 * returns the text. As with every adapter, the host injects that call; the
 * shared base supplies framing + parsing. The only host-specific surface here
 * is the `host` identifier (`"codex"`, matching the sessionArchive adapter
 * convention) and the typed error.
 */

/** Codex's inline-completion invoker — a `prompt in, string out` call. */
export type CodexCompletionInvoker = InjectedInvoker;

export class CodexLLMJudgeError extends LLMJudgeError {
  constructor(message: string, raw?: string) {
    super(message, raw);
    this.name = "CodexLLMJudgeError";
  }
}

export class CodexLLMJudge extends InjectedLLMJudge {
  readonly host = "codex";

  protected override makeError(message: string, raw?: string): Error {
    return new CodexLLMJudgeError(message, raw);
  }
}
